import styled from 'styled-components';
import { colours, common } from 'themes/default';
import Button from 'components/ui/Button';

const FareDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
`;

const ClassOfService = styled.span``;

const Container = styled.div`
  border-top: 1px solid ${colours.Greyscale.CharcoalGrey};
  box-sizing: border-box;
  padding: 0 16px 4px 16px;
  position: relative;

  &:before {
    background: ${({ classOfServiceCode }) => common.classes[classOfServiceCode] ?? common.classes.default};
    content: '';
    display: block;
    height: 0.5rem;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

const SeeMore = styled(Button)`
  margin-top: 0;
  /* border-color: #00286a;
  color: #00286a; */
`;

const StyledContainer = styled.div`
  display: flex;
`;
const StyledNewFaresConditions = styled.div`
  color: ${colours.Messaging.ErrorRed};
  margin: 10px 20px;
`;
const StyledFareSummary = styled.div`
  border: 1px solid #00286a;
  border-radius: 3px;
  padding: 4px 6px 4px;
  margin: 2px 0px 4px;
`;

export { Container, ClassOfService, FareDetails, SeeMore, StyledNewFaresConditions, StyledContainer, StyledFareSummary };
